<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 17:27:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-08-13 11:28:33
 * @name: 品牌系列型号管理
 * @Description: 品牌系列型号管理
 * @FilePath: \backstage\src\views\goodsManage\modelGoodsManage.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <layout-normal>
    <table-brand
      ref="tableBrand"
      :step.sync="step"
      :modelGoods="modelGoods"
    ></table-brand>
    <table-series
      ref="tableSeries"
      :step.sync="step"
      :modelGoods="modelGoods"
      @getNewTableData="getNewTableData"
    ></table-series>
    <table-model
      ref="tableModel"
      :step.sync="step"
      :modelGoods="modelGoods"
      @getNewTableData="getNewTableData"
    ></table-model>
  </layout-normal>
</template>
<script>
import tableBrand from "@/components/modelGoodsManage/table-brand.vue";
import tableSeries from "@/components/modelGoodsManage/table-series.vue";
import tableModel from "@/components/modelGoodsManage/table-model.vue";
import modelGoods from "@/object/goods/modelGoods.class.js";

export default {
  name: "modelGoodsManage",
  components: {
    tableBrand,
    tableSeries,
    tableModel,
  },
  data() {
    // methods -> initData内初始化
    return {
      step: 1, //表格层级
      modelGoods: new modelGoods(),
    };
  },
  // 页面第一次进入时刷新页面
  activated() {
    this.refresh();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 刷新页面
     */
    refresh() {
      this.initData();
      this.$nextTick(() => {
        this.$refs.tableBrand.refresh();
        this.$refs.tableSeries.refresh();
        this.$refs.tableModel.refresh();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */
    initData() {
      this.step = 1; //表格层级
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取新的表格数据
     * @param ref 子组件ref
     */    
    getNewTableData(ref) {
      this.$refs[ref].getTableData();
    }
  },
};
</script>
<style lang="scss" scoped>
.el-table {
  .el-button {
    margin: 0;
    padding: 0 6px;
  }
  .clip {
    color: $Vars-font-placeholder-color;
  }
  /deep/ .el-switch__core:before {
    content: "隐";
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 21px;
  }
  /deep/.is-checked .el-switch__core:before {
    content: "显" !important;
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 5px;
  }
}
/deep/ .el-table__fixed-right::before,
.el-table__fixed::before {
  height: 0 !important;
}
</style>
